/** Domain service module: legalPerson.js */
import { request } from '../http/request'
import { API_BASE_URL } from './config'
import { auth } from './auth'

class LegalPersonService {
  updateLegalPerson(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _resultLegalPerson = await request(`${API_BASE_URL}/legalPerson/update/${data.id || ''}`, 'post', data)
        let _user = auth.user()
        _user.legal_person = _resultLegalPerson?.data?.data
        localStorage.user = JSON.stringify(_user)
        resolve(_resultLegalPerson?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  updateMyLegalPerson(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _resultLegalPerson = await request(`${API_BASE_URL}/legalPerson/updateMe`, 'post', data)
        let _user = auth.user()
        _user.legal_person = _resultLegalPerson?.data?.data
        localStorage.user = JSON.stringify(_user)
        resolve(_resultLegalPerson?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  updateMyLegalPersonAdmin(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let _resultLegalPerson = await request(`${API_BASE_URL}/legalPerson/updateAdmin`, 'post', data)
        resolve(_resultLegalPerson?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  search(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let _resultLegalPerson = await request(`${API_BASE_URL}/legalPerson/search`, 'post', data)
        resolve(_resultLegalPerson?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  list(data, page) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _resultLegalPerson = await request(`${API_BASE_URL}/legalPerson/list?page=${page || 1}`, 'post', data)
        resolve(_resultLegalPerson?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  listDependants() {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _resultLegalPerson = await request(`${API_BASE_URL}/legalPerson/listDependants`, 'get')
        resolve(_resultLegalPerson?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  get(id) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _resultLegalPerson = await request(`${API_BASE_URL}/legalPerson/${id}`, 'post')
        resolve(_resultLegalPerson?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  delete(id) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/legalPerson/delete/${id}`, 'delete')
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  removeNotification(number) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _resultLegalPerson = await request(`${API_BASE_URL}/legalPerson/removeNotificationNumber/${number}`, 'get')
        resolve(_resultLegalPerson?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  acceptNotifications(number) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _resultLegalPerson = await request(`${API_BASE_URL}/legalPerson/acceptNotificationNumber/${number}`, 'get')
        resolve(_resultLegalPerson?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  resendWhatsAppConfirmation(legal_person_id) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/legalPerson/resendWhatsAppConfirmation/${legal_person_id}`, 'post')
        resolve(_result?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  transferGroup(data) {
    return new Promise(async (resolve, reject) => {
      try {
        const _result = await request(`${API_BASE_URL}/legalPerson/transferGroup`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }
}

class MedicalRecordService {
  update(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/medicalRecord/update`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  updateAdmin(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/medicalRecord/updateAdmin`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
}

class LegalPersonParentService {
  update(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/legalPersonParent/update`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
}

export const legalPerson = new LegalPersonService()
export const medicalRecord = new MedicalRecordService()
export const legalPersonParent = new LegalPersonParentService()
